import clsx from 'clsx';
import Text from '@/components/Text/Text';
import styles from './Testimonial.module.scss';

export interface TestimonialProps {
  author: string;
  id: number;
  review: string;
  quote: string;
  backgroundColor?: 'dark' | 'light';
}

const Testimonial = ({ data }: { data: TestimonialProps }) => (
  <section className={styles.testimonialWrapper}>
    <section className={clsx(styles.testimonial, { [styles.dark]: data.backgroundColor === 'dark' })}>
      <h4 className={styles.quote}>{data.review}</h4>
      <div className={styles.author}>
        <Text
          tag='p'
          isBold
        >
          {data.author}
        </Text>
      </div>
    </section>
  </section>
);
export default Testimonial;
